/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";

import { PaymentAlert } from "./components/PaymentAlert";
import { ReceiptButton } from "./components/ReceiptButton";

import type { FC } from "react";

type Props = {
  isPayPalPending: boolean;
  isPurchased: boolean;
  isReceiptAvailable: boolean;
  onContinuePayment: () => void;
  onShowReceipt: () => void;
  showPaymentAlert: boolean;
};

export const ReceiptOrPaymentAlert: FC<Props> = (props) => {
  const {
    isPayPalPending,
    isPurchased,
    isReceiptAvailable,
    onContinuePayment,
    onShowReceipt,
    showPaymentAlert,
  } = props;

  if (isPurchased) {
    if (!isReceiptAvailable) return null;
    return <ReceiptButton onShowReceipt={onShowReceipt} />;
  }

  if (showPaymentAlert) {
    return (
      <PaymentAlert
        isPayPalPending={isPayPalPending}
        onContinuePayment={onContinuePayment}
      />
    );
  }

  return null;
};
